import map from 'lodash/fp/map'
import over from 'lodash/fp/over'
import pipe from 'lodash/fp/pipe'
import zipObject from 'lodash/fp/zipObject'
import * as Redux from 'redux'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

export interface FormAction<Value> extends Redux.Action {
  value: Value
}

export type CancelAction = Redux.Action
export type EnterAction<T> = FormAction<Types.Fields<T>>
export type ExitAction = Redux.Action
export type ResetAction = Redux.Action
export type SaveAction<T> = FormAction<T>
export type SaveCompleteAction = Redux.Action
export type UpdateFieldAction = FormAction<Types.Field<string>>
export type ValidationAction = FormAction<boolean>

export type Cancel = Redux.ActionCreator<CancelAction>
export type Enter<T> = Redux.ActionCreator<EnterAction<T>>
export type Exit = Redux.ActionCreator<ExitAction>
export type Reset = Redux.ActionCreator<ResetAction>
export type Save<T> = Redux.ActionCreator<SaveAction<T>>
export type SaveComplete = Redux.ActionCreator<SaveCompleteAction>
export type UpdateField = Redux.ActionCreator<UpdateFieldAction>
export type Validation = Redux.ActionCreator<ValidationAction>

export const createFormActions = pipe(
  Utils.createFormConstants,
  map((type) => <Value>(value: Value) => ({type, value})),
)

export type Actions<T> = CancelAction
  & EnterAction<T>
  & ExitAction
  & ResetAction
  & SaveAction<T>
  & SaveCompleteAction
  & UpdateFieldAction
  & ValidationAction

export type FormActionCreator<T> = Redux.ActionCreator<Actions<T>>

export interface ActionsMap<T> {
  [key: string]: FormActionCreator<T>
}
export type CreateActionsMap = <T>(prefix: string) => ActionsMap<T>
export const createActionsMap: CreateActionsMap = pipe(
  createFormActions,
  zipObject(Constants.verbs),
)

export interface ConstantsMap {[key: string]: string}

export const ACTION_INDEX = 0
export const CONSTANTS_INDEX = 1
export type FormDataMap<T> = [ActionsMap<T>, ConstantsMap]

export type CreateMaps = <T>(prefix: string) => FormDataMap<T>
export const createMaps = over<any>([
  createActionsMap,
  Utils.createConstantsMap,
])



// WEBPACK FOOTER //
// ./src/components/form/actions.ts